import { defineMessages } from 'react-intl';

const messages = defineMessages({
  unishippersTitle: {
    description: 'unishippers page title',
    defaultMessage: 'Unishippers',
    id: 'LgN8bp',
  },
  customerNumberLabel: {
    description: 'unishippers customer number',
    defaultMessage: 'Customer Number',
    id: '26BpYN',
  },
  passwordLabel: {
    description: 'unishippers password',
    defaultMessage: 'Password',
    id: 'RMCiEm',
  },
  userNameLabel: {
    description: 'unishippers user name',
    defaultMessage: 'User Name',
    id: '1RfAho',
  },
  enableUnishippers: {
    description: 'enable unishippers button',
    defaultMessage: 'Enable Unishippers',
    id: 'qMMkcK',
  },
  unishippersSuccessMessage: {
    description: 'unishippers success message',
    defaultMessage: 'Unishippers configuration saved successfully',
    id: 'YOmYv/',
  },
  unishippersFailureMessage: {
    description: 'unishippers failure message',
    defaultMessage: 'Failed to save Unishippers configuration, please try again later',
    id: '6cIwrS',
  },
  step1: {
    description: 'unishippers step 1',
    defaultMessage: 'Step 1: <a>Click here</a> to set up a Unishippers Pricelink rating account.',
    id: 'mD7hVP',
  },
  step2: {
    description: 'unishippers step 2',
    defaultMessage: 'Step 2: Enter your Pricelink rating account credentials below:',
    id: 'Ky2sHU',
  },
});

export default messages;
